import { resolve } from 'styled-jsx/css';

/* istanbul ignore next */
export default resolve`
  .ad {
    text-align: center;
  }

  .with-auto-margin {
    margin: 0 auto;
  }
`;
